import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackJoinHappyParentsPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-how-water-plants')
  }

  return (
    <FeedbackPage
      emoji="💚"
      heading={t('pages.onboarding.feedbackJoinHappyParents.heading')}
      text={t('pages.onboarding.feedbackJoinHappyParents.text')}
      onSubmit={handleSubmit}
    />
  )
}
